import React, { useCallback, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import AuthContext from "../../store/auth-context";
import { useTranslation } from "react-i18next";
import { teleconsulationService } from "../../services/teleconsult.service";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Snackbar,
  TextField,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import CloseIcon from "@material-ui/icons/Close";
import DoctorProfile from "../doctor/DoctorProfile";
import SearchIcon from "@mui/icons-material/Search";

const searchPlaceholder = ["Name", "Language", "Disease"];

function TeleDoctorsList(props: any) {
  const history = useHistory();
  const authCtx = useContext(AuthContext);
  const { t } = useTranslation();
  const [doctorResultList, setDoctorResultList] = useState<any>([]);
  const [doctorResultListBakup, setDoctorResultListBakup] = useState<any>([]);
  const [isError, setIsError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<any>("");
  const [doctorProfileDialog, setDoctorProfileDialog] =
    useState<boolean>(false);
  const [doctorProfile, setDoctorProfile] = useState<any>();
  const [doctorSearchString, setDoctorSearchString] = useState<string>("");
  const [placeholderString, setPlaceholderString] = useState<string>("");

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  useEffect(() => {
    const getTeleconsultationDoctor = () => {
      fetchTeleconsultationDoctor();
    };
    getTeleconsultationDoctor();
    // eslint-disable-next-line
  }, []);

  const shuffle = useCallback(() => {
    const index = Math.floor(Math.random() * searchPlaceholder.length);
    setPlaceholderString(searchPlaceholder[index]);
  }, []);

  useEffect(() => {
    const intervalID = setInterval(shuffle, 1000);
    return () => clearInterval(intervalID);
  }, [shuffle]);

  const sortDoctorsList = (doctorslist: any) => {
    doctorslist.sort((a: any, b: any) =>
      a.name.toLowerCase() > b.name.toLowerCase()
        ? 1
        : b.name.toLowerCase() > a.name.toLowerCase()
        ? -1
        : 0
    );
    return doctorslist;
  };

  const fetchTeleconsultationDoctor = async () => {
    authCtx.toggleLoader(true);
    let res = await teleconsulationService.getTelecosnultationDoctor(
      user.vblog
    );

    if (res && res.data && res.data.status && res.data.status === "success") {
      const doctorData = sortDoctorsList(res.data.data);
      setDoctorResultList(doctorData);
      setDoctorResultListBakup(doctorData);
      setIsError(false);
      authCtx.toggleLoader(false);
    } else {
      setDoctorResultList([]);
      setDoctorResultListBakup([]);
      setIsError(true);
      setErrorMessage(t("Something went wrong!"));
      authCtx.toggleLoader(false);
    }
  };

  const bookAppointment = (doctorDetail: any) => {
    props.setSelectedProcess("doctor-selection-completed");
    props.setDoctorDetails(doctorDetail);
  };

  const handleDoctorProfile = (item: any) => {
    setDoctorProfile(item);
    setDoctorProfileDialog(true);
  };

  const hanldeDoctorProfileDialogClose = () => {
    setDoctorProfileDialog(false);
  };

  const handleInputChange = (e: any) => {
    e.preventDefault();
    setDoctorSearchString(e.target.value);
    handleDoctorSearch(e.target.value);
  };

  const handleDoctorSearch = (searchString: any) => {
    if (searchString === "") {
      setDoctorResultList(doctorResultListBakup);
    } else {
      if (searchString.length > 2) {
        const filteredItems: any = doctorResultListBakup.filter((item: any) => {
          return (
            item.name.toLowerCase().includes(searchString.toLowerCase()) ||
            (item.know_langauges &&
              item.know_langauges
                .toLowerCase()
                .includes(searchString.toLowerCase())) ||
            (item.disease_key &&
              item.disease_key
                .toLowerCase()
                .includes(searchString.toLowerCase()))
          );
        });
        setDoctorResultList(filteredItems);
      }
    }
  };

  return (
    <>
      <div className="mt-3" key={"select-doctor-start"}>
        <div className="d-flex justify-content-between align-items-center">
          <p className="fs-18 fw-600 mb-0 mt-1" key="select-patient-1">
            {t("Available Doctors")}
          </p>

          <TextField
            id="searchString"
            type="search"
            autoComplete="off"
            placeholder={t("Search Doctor By" + " " + placeholderString)}
            className="form-control me-sm-3 fs-14 w-25"
            variant="outlined"
            size="small"
            value={doctorSearchString}
            onChange={(e: any) => handleInputChange(e)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon className="text-secondary" />
                </InputAdornment>
              ),
            }}
          />
        </div>

        <div className="row g-3 mt-1">
          {doctorResultList.length > 0 &&
            doctorResultList.map((item: any, index: any) => (
              <div className="col-sm-6 col-md-4 col-xl-3" key={index}>
                <div className="card border-0 shadow-sm rounded-1rem text-center h-100 doc-profile-container">
                  {/* <i className="material-icons-outlined btn btn-link text-decoration-none doc-profile-icon fs-1" onClick={()=> setDoctorProfileDialog(true)}>
                          info
                          </i> */}

                  <div className="card-body tele-dr-border rounded-1rem h-100 p-0">
                    <div className="tele-dr-bg">
                      <img
                        src={item.image ? item.image : "/assets/images/doc.png"}
                        className="tele-dr-photo"
                        alt=""
                      />
                    </div>

                    <div className="text-start w-100 px-3">
                      <h6 className="fw-bold mt-3 text-truncate mb-2">
                        {item.name}
                      </h6>
                      <p className="fw-bold text-muted mb-1 text-truncate fs-12">
                        <i className="fa-solid fa-language fs-14 me-2"></i>
                        {item.know_langauges ? item.know_langauges : "English"}
                      </p>
                      <p className="fw-bold text-muted mb-1 text-truncate fs-12">
                        <i className="fa-solid fa-briefcase fs-14 me-2"></i>
                        {item.experience} {t("Years of Experience")}
                      </p>
                      <p className="fw-bold text-muted mb-1 text-truncate fs-12">
                        <i className="fa-solid fa-capsules fs-14 me-2"></i>
                        {t("General Practitioner")}
                      </p>
                    </div>
                    <div className="px-2 mt-3">
                      <button
                        onClick={() => bookAppointment(item)}
                        className="btn btn-primary w-100 position-relative bottom-0 btn-primary-linear"
                      >
                        {t("Book Teleconsultation")}
                      </button>
                      <button
                        className="btn btn-link no-focus mt-1"
                        onClick={() => handleDoctorProfile(item)}
                      >
                        {t("View Profile")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}

          {doctorResultList.length === 0 && (
            <div className="card border-0 shadow-sm rounded-1rem text-center">
              <div className="card-body pt-4">
                <div className="text-center">
                  <h5>{t("No Doctors to display")}</h5>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={doctorProfileDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          {t("Doctor's Profile")}
          <IconButton
            className="float-end p-1"
            aria-label="close"
            onClick={() => hanldeDoctorProfileDialogClose()}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DoctorProfile doctorProfileDetails={doctorProfile} />
        </DialogContent>
      </Dialog>

      <Snackbar
        open={isError}
        autoHideDuration={3000}
        onClose={() => setIsError(false)}
      >
        <Alert onClose={() => setIsError(false)} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default TeleDoctorsList;
